module.exports = __webpack_public_path__ + "img/tuijianjigou2.c6c371d8.png";